export enum AuthzRelation {
    Viewer = 'viewer',
    Editor = 'editor',
}
